import React from "react";
import {
  Wallet,
  TrendingUp,
  TrendingDown,
  CreditCard,
  Target,
  PiggyBank,
  Bell,
  CheckCircle2,
  ArrowUpRight,
  ArrowDownRight,
} from "lucide-react";

/* Conteúdo "tall" que rola dentro do celular */
const ScrollingScreen = () => (
  <div className="phone-scroll-track px-4 py-5 space-y-4">
    {/* Header app */}
    <div className="flex items-center justify-between">
      <div>
        <div className="text-[10px] text-slate-400">Olá, Você</div>
        <div className="text-base font-display font-bold text-white">Bom dia ☀️</div>
      </div>
      <div className="h-8 w-8 rounded-full bg-gradient-to-br from-emerald-500 to-blue-600 grid place-items-center text-white text-xs font-bold">VC</div>
    </div>

    {/* Saldo */}
    <div className="rounded-2xl p-4 bg-gradient-to-br from-emerald-500 to-emerald-700 text-white">
      <div className="text-[10px] uppercase tracking-wider opacity-80">Saldo Atual</div>
      <div className="text-2xl font-display font-bold mt-1">R$ 18.412,50</div>
      <div className="flex items-center gap-1 text-[11px] mt-1 opacity-90">
        <TrendingUp className="h-3 w-3" /> +12,4% este mês
      </div>
    </div>

    {/* Quick stats */}
    <div className="grid grid-cols-2 gap-2">
      <div className="rounded-xl p-3 bg-slate-800 border border-slate-700">
        <div className="flex items-center gap-1 text-[10px] text-blue-400"><ArrowUpRight className="h-3 w-3" /> Receitas</div>
        <div className="text-sm font-bold text-white mt-1">R$ 9.200</div>
      </div>
      <div className="rounded-xl p-3 bg-slate-800 border border-slate-700">
        <div className="flex items-center gap-1 text-[10px] text-amber-400"><ArrowDownRight className="h-3 w-3" /> Despesas</div>
        <div className="text-sm font-bold text-white mt-1">R$ 5.100</div>
      </div>
    </div>

    {/* Mini chart */}
    <div className="rounded-xl p-3 bg-slate-800 border border-slate-700">
      <div className="text-[11px] font-semibold text-slate-300 mb-2">Últimos 6 meses</div>
      <svg viewBox="0 0 200 60" className="w-full h-14">
        <defs>
          <linearGradient id="mg" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#10b981" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#10b981" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d="M0,40 C30,30 50,20 80,25 C110,30 130,15 160,18 C180,20 195,10 200,12 L200,60 L0,60 Z" fill="url(#mg)" />
        <path d="M0,40 C30,30 50,20 80,25 C110,30 130,15 160,18 C180,20 195,10 200,12" stroke="#10b981" strokeWidth="2" fill="none" />
      </svg>
    </div>

    {/* Lembrete Push */}
    <div className="flex gap-3 animate-slide-up" style={{ animationDelay: "1.4s" }}>
      <div className="h-8 w-8 rounded-full bg-emerald-500/20 grid place-items-center text-emerald-400 shrink-0 border border-emerald-500/30">
        <CheckCircle2 className="h-4 w-4" />
      </div>
      <div className="bg-slate-900 rounded-2xl rounded-tl-sm p-3 border border-slate-800 shadow-sm">
        <div className="text-sm text-slate-200">Gasto com <span className="text-emerald-400 font-semibold">Aluguel</span> anotado!</div>
        <div className="text-[10px] text-slate-300">R$ 1.240,00 · registrado via áudio</div>
      </div>
    </div>

    {/* Transações */}
    <div className="rounded-xl p-3 bg-slate-800 border border-slate-700 space-y-2">
      <div className="text-[11px] font-semibold text-slate-300">Hoje</div>
      {[
        { i: "🛒", t: "Mercado Dia", c: "Alimentação", v: "-R$ 189,90", neg: true },
        { i: "🚗", t: "Uber", c: "Transporte", v: "-R$ 45,00", neg: true },
        { i: "💰", t: "Salário", c: "Receita", v: "+R$ 6.500,00", neg: false },
      ].map((t) => (
        <div key={t.t} className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded-lg bg-slate-700 grid place-items-center text-sm">{t.i}</div>
            <div>
              <div className="text-[11px] text-white">{t.t}</div>
              <div className="text-[9px] text-slate-400">{t.c}</div>
            </div>
          </div>
          <div className={`text-[11px] font-semibold ${t.neg ? "text-white" : "text-emerald-400"}`}>{t.v}</div>
        </div>
      ))}
    </div>

    {/* Metas */}
    <div className="rounded-xl p-3 bg-slate-800 border border-slate-700">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Target className="h-3.5 w-3.5 text-emerald-400" />
          <div className="text-[11px] font-semibold text-white">Meta Viagem</div>
        </div>
        <div className="text-[11px] text-emerald-400 font-bold">76%</div>
      </div>
      <div className="h-1.5 bg-slate-700 rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-emerald-400 to-blue-400 rounded-full" style={{ width: "76%" }} />
      </div>
      <div className="flex items-center justify-between mt-1.5 text-[10px] text-slate-400">
        <span>R$ 3.800 guardado</span>
        <span>R$ 5.000</span>
      </div>
    </div>

    {/* Investimentos */}
    <div className="rounded-2xl p-4 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
      <div className="flex items-center gap-2 mb-2">
        <PiggyBank className="h-4 w-4" />
        <div className="text-[10px] uppercase tracking-wider opacity-80">Investimentos</div>
      </div>
      <div className="text-xl font-display font-bold">R$ 24.380,00</div>
      <div className="text-[10px] opacity-90 mt-1">+R$ 312 hoje · CDI 13,75%</div>
    </div>

    {/* Cartão de Crédito */}
    <div className="rounded-xl p-3 bg-slate-800 border border-slate-700">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <CreditCard className="h-3.5 w-3.5 text-blue-400" />
          <div className="text-[11px] font-semibold text-white">Fatura Visa</div>
        </div>
        <div className="text-[10px] text-slate-400">Vence 15/01</div>
      </div>
      <div className="text-base font-bold text-white">R$ 2.189,40</div>
      <div className="h-1.5 bg-slate-700 rounded-full mt-2 overflow-hidden">
        <div className="h-full bg-amber-400 rounded-full" style={{ width: "43%" }} />
      </div>
      <div className="flex items-center justify-between mt-1.5 text-[10px] text-slate-400">
        <span>43% do limite</span>
        <span>de R$ 5.000</span>
      </div>
    </div>

    {/* Footer cards */}
    <div className="rounded-xl p-3 bg-emerald-500/10 border border-emerald-500/30 flex items-start gap-2">
      <CheckCircle2 className="h-4 w-4 text-emerald-400 shrink-0 mt-0.5" />
      <div className="text-[10px] text-emerald-200">
        Você economizou <b className="text-white">R$ 412</b> este mês comparado com a média dos últimos 6 meses. 🎉
      </div>
    </div>

    <div className="h-6" />
  </div>
);

const MobileShowcase = () => (
  <section 
    className="py-20 md:py-28 relative overflow-hidden" 
    style={{ background: 'linear-gradient(135deg, #137072 0%, #061124 100%)' }}
    data-testid="mobile-showcase"
  >
    {/* glow background */}
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-gradient-to-br from-emerald-500/10 via-transparent to-blue-500/10 blur-3xl pointer-events-none" />

    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <div className="text-center max-w-2xl mx-auto">
        <span className="pill">SEU MONYXX NO BOLSO</span>
        <h2 className="mt-4 text-3xl md:text-5xl font-display font-bold leading-tight">
          Tudo que importa, <span className="monyx-grad-text">na palma da mão</span>
        </h2>
        <p className="mt-4 text-slate-300 text-lg">
          Painel completo, gráficos, metas, cartões e o agente IA por voz — tudo dentro de um app
          rápido, leve e que você instala em um toque.
        </p>
      </div>

      {/* Phone */}
      <div className="mt-14 flex justify-center">
        <div className="relative">
          {/* Outer frame */}
          <div className="relative w-[300px] sm:w-[330px] h-[640px] rounded-[44px] bg-slate-900 border-[6px] border-slate-800 shadow-2xl shadow-emerald-500/10 overflow-hidden ring-1 ring-white/5">
            {/* Notch */}
            <div className="absolute top-2 left-1/2 -translate-x-1/2 z-10 w-28 h-6 bg-slate-950 rounded-full" />
            {/* Screen */}
            <div className="absolute inset-0 bg-slate-950 overflow-hidden rounded-[36px]">
              <ScrollingScreen />
            </div>
            {/* Top fade */}
            <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-slate-950 to-transparent pointer-events-none z-[5]" />
            {/* Bottom fade */}
            <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-slate-950 to-transparent pointer-events-none z-[5]" />
          </div>
          {/* Side reflections */}
          <div className="absolute -inset-6 -z-10 rounded-[60px] bg-gradient-to-br from-emerald-500/10 to-blue-500/10 blur-2xl" />
        </div>
      </div>

      {/* Bullet points */}
      <div className="mt-12 grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
        {[
          { i: <Wallet className="h-4 w-4" />, t: "Saldos consolidados em tempo real" },
          { i: <Bell className="h-4 w-4" />, t: "Alertas e notificações personalizadas" },
          { i: <Target className="h-4 w-4" />, t: "Metas com progresso visual" },
        ].map((b) => (
          <div key={b.t} className="flex items-center gap-3 p-3 rounded-xl bg-slate-900 border border-slate-800">
            <div className="h-9 w-9 rounded-lg bg-emerald-500/10 text-emerald-400 grid place-items-center">{b.i}</div>
            <div className="text-sm text-slate-200">{b.t}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default MobileShowcase;
